// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function record_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var amount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
  if (amount.TAG === /* Ok */0) {
    var created_at = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
    if (created_at.TAG === /* Ok */0) {
      var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var admin_email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "admin_email"), null));
        if (admin_email.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    amount: amount._0,
                    created_at: created_at._0,
                    status: status._0,
                    admin_email: admin_email._0
                  }
                };
        }
        var e = admin_email._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".admin_email" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = created_at._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".created_at" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = amount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".amount" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var instamojo_payment_records = Decco.listFromJson(record_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "instamojo_payment_records"), null));
  if (instamojo_payment_records.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              instamojo_payment_records: instamojo_payment_records._0
            }
          };
  }
  var e = instamojo_payment_records._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".instamojo_payment_records" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  record_decode ,
  t_decode ,
  
}
/* No side effect */
